import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class LayoutContainerComponent {}
